import React from 'react';
import { Link } from 'react-router-dom';
import { Edit3 } from 'lucide-react';

const ChatList = ({ chats }) => {
  return (
    <div className="screen">
      <div className="screen-header">
        <h1 className="screen-title">Messages</h1>
        <p className="screen-subtitle">Stay connected with nomads</p>
      </div>

      <div>
        {chats.map((chat) => (
          <Link key={chat.id} to={`/chat/${chat.id}`} className="chat-item">
            <div className="chat-avatar-container">
              <img src={chat.avatar} alt={chat.name} className="chat-avatar" />
              {chat.isOnline && !chat.isGroup && <div className="online-indicator" />}
            </div>
            
            <div className="chat-info">
              <div className="chat-name">
                {chat.name}
                {chat.isGroup && <span style={{ 
                  marginLeft: '8px', 
                  fontSize: '11px', 
                  background: 'rgba(102, 126, 234, 0.1)',
                  color: '#667eea',
                  padding: '2px 6px',
                  borderRadius: '4px'
                }}>
                  Group
                </span>}
              </div>
              <div className="chat-message">{chat.lastMessage}</div>
            </div>
            
            <div className="chat-meta">
              <div className="chat-time">{chat.time}</div>
              {chat.unread > 0 && (
                <div className="unread-badge">{chat.unread}</div>
              )}
            </div>
          </Link>
        ))}
      </div>

      {/* Floating New Chat Button */}
      <button className="add-btn">
        <Edit3 size={20} />
      </button>
    </div>
  );
};

export default ChatList;